<template>
<slide-y-up-transition>
  <v-select multiple v-model="localValue" :placeholder="placeholder" :options="localOptions" :filtered="filtered" :searchable="searchable" :label="label" :value="valueProp" :closeOnSelect="closeOnSelect" :loading="isLoading" :disabled="disabled" :reduce="reduce">
    <template #open-indicator="{ attributes }">
      <span v-bind="attributes">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
          <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z" transform="translate(12) rotate(90)" fill="#8a8a8a"/>
        </svg>
      </span>
    </template>
    <template #no-options>
      {{$t('base-select.noOptions')}}
    </template>
  </v-select>
</slide-y-up-transition>
</template>

<script>
import '@/plugins/vue-select'
import { get } from 'lodash'
import { SlideYUpTransition } from 'vue2-transitions'

export default {
  name: 'base-select',
  components: {
    SlideYUpTransition
  },
  props: {
    value: Array,
    placeholder: {
      type: String,
      required: false,
      default () {
        return this.$t('base-select.select-option')
      }
    },
    options: Array,
    filtered: {
      type: Boolean,
      required: false,
      default: false
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'label'
    },
    valueProp: {
      type: String,
      required: false,
      default: 'value'
    },
    loading: {
      type: Boolean,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      localValue: [],
      localOptions: []
    }
  },
  methods: {
    reduce (item) {
      if (item) {
        return item[this.valueProp]
      } else {
        return null
      }
    },
    mapOption (option) {
      if (!option) { return null }
      let mappedOpt = {}
      mappedOpt[this.label] = get(option, this.label)
      mappedOpt[this.valueProp] = get(option, this.valueProp)
      return mappedOpt
    }
  },
  computed: {
    isLoading () {
      return this.loading ? this.loading : (!this.options || this.options.length === 0)
    }
  },
  created () {
    this.uid = this._uid.toString()
    this.localValue = this.value
    this.localOptions = this.options.map((item) => {
        return this.mapOption(item)
      })
    /* this.$watch('value', (value, old) => {
      if (!old || (value && old.value !== value.value)) {
        this.localValue = this.mapOption(value)
      }
    }) */
    this.$watch('localValue', value => {
      this.$emit('input', value)
      this.$emit('change', value)
    })
    this.$watch('value', value => {
      this.localValue = value
    })
    this.$watch('options', value => {
      this.localOptions = value.map((item) => {
        return this.mapOption(item)
      })
    })
  }
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseMultiSelect.vue